import { Badge } from '#~/video/components/badge/index.js';
import { BadgeStatus } from '#~/video/components/badge/types.js';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';
import { castId } from '@studio/models/identifier';
import type { Device } from '@studio/models/device';

/** `<VideoBadges>` exhibit. */
export const VideoBadges = (): ReactElement => {
  // Create a valid Device ID using castId
  const demoDeviceId = castId<Device['id']>('demo-device-1');

  return (
    <Exhibit title='Video Badge Statuses'>
      <div className='flex flex-col gap-16'>
        <Column className='min-w-0 max-w-min'>
          <div className='font-bold'>Connection Statuses</div>
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_CONNECTING} deviceId={demoDeviceId} />
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_CONNECTED} deviceId={demoDeviceId} />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_MOVEMENT_CONNECTING}
            deviceId={demoDeviceId}
          />
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_VIDEO_CONNECTING} deviceId={demoDeviceId} />
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_AUDIO_CONNECTING} deviceId={demoDeviceId} />
        </Column>

        <Column className='min-w-0 max-w-min'>
          <div className='font-bold'>Connection Failure Statuses</div>
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_MOVEMENT_CONNECTION_FAILED}
            deviceId={demoDeviceId}
          />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_VIDEO_CONNECTION_FAILED}
            deviceId={demoDeviceId}
          />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_AUDIO_CONNECTION_FAILED}
            deviceId={demoDeviceId}
          />
        </Column>

        <Column className='min-w-0 max-w-min'>
          <div className='font-bold'>Device Power Statuses</div>
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_BOOTING} deviceId={demoDeviceId} />
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_SHUTTING_DOWN} deviceId={demoDeviceId} />
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_REBOOTING} deviceId={demoDeviceId} />
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_IDLE} deviceId={demoDeviceId} />
        </Column>

        <Column className='min-w-0 max-w-min'>
          <div className='font-bold'>Calibration Statuses</div>
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_CALIBRATING} deviceId={demoDeviceId} />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_CALIBRATION_FAILED}
            deviceId={demoDeviceId}
          />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_CALIBRATION_SUCCEEDED}
            deviceId={demoDeviceId}
          />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_CALIBRATION_GENERIC}
            deviceId={demoDeviceId}
          />
        </Column>

        <Column className='min-w-0 max-w-min'>
          <div className='font-bold'>Bridge Status</div>
          <Badge badgeStatus={BadgeStatus.BADGE_STATUS_BRIDGE_OFFLINE} deviceId={demoDeviceId} />
        </Column>

        <Column className='min-w-0 max-w-min'>
          <div className='font-bold'>Calibration Progress</div>
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_CALIBRATING}
            calibrationProgress={25}
            deviceId={demoDeviceId}
          />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_CALIBRATING}
            calibrationProgress={50}
            deviceId={demoDeviceId}
          />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_CALIBRATING}
            calibrationProgress={75}
            deviceId={demoDeviceId}
          />
          <Badge
            badgeStatus={BadgeStatus.BADGE_STATUS_CALIBRATING}
            calibrationProgress={99}
            deviceId={demoDeviceId}
          />
        </Column>
      </div>
    </Exhibit>
  );
};
